import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { MAP_TOOL, LAYER_IDS } from '@tmapy/config';
import { actionDeleteAllFeatures } from '@tmapy/mapcore';
import { BtnBar, SvgLine, SvgPolygon, SecondaryBtn } from '@tmapy/style-guide';
import { Measurement } from './Measurement';
import { measureMessages } from './measureMessages';
import { actionDeactivateMeasure, actionSetMeasureLine, actionSetMeasurePolygon } from '../actions';
export const Measure = ({ activeMapTool, features, dispatch }) => {
    const isMeasureLineActive = activeMapTool === MAP_TOOL.MEASURE_LINE;
    const isMeasurePolygonActive = activeMapTool === MAP_TOOL.MEASURE_POLYGON;
    const handleMeasureLineBtnClick = useCallback(() => {
        if (isMeasureLineActive) {
            dispatch(actionDeactivateMeasure());
        }
        else {
            dispatch(actionSetMeasureLine());
        }
    }, [dispatch, isMeasureLineActive]);
    const handleMeasurePolygonBtnClick = useCallback(() => {
        if (isMeasurePolygonActive) {
            dispatch(actionDeactivateMeasure());
        }
        else {
            dispatch(actionSetMeasurePolygon());
        }
    }, [dispatch, isMeasurePolygonActive]);
    const handleDeleteAllMeasurementsBtnClick = useCallback(() => {
        dispatch(actionDeleteAllFeatures(LAYER_IDS.MEASURE));
    }, [dispatch]);
    return (_jsxs(_Fragment, { children: [_jsxs(BtnBar, { stretch: true, children: [_jsx(SecondaryBtn, { icon: { element: _jsx(SvgLine, {}) }, isActive: isMeasureLineActive, onClick: handleMeasureLineBtnClick, children: _jsx(FormattedMessage, { ...measureMessages.measureLine }) }), _jsx(SecondaryBtn, { icon: { element: _jsx(SvgPolygon, {}) }, isActive: isMeasurePolygonActive, onClick: handleMeasurePolygonBtnClick, children: _jsx(FormattedMessage, { ...measureMessages.measurePolygon }) })] }), _jsx("div", { className: 'sg-u-vs-1', children: features.map((feature) => (_jsx("section", { className: 'sg-u-box sg-a-p-1', "data-icon-btn-hover": true, children: _jsx(Measurement, { feature: feature, projection: 'EPSG:5514', dispatch: dispatch }) }, feature.properties.id))) }), features.length > 0 && (_jsx(BtnBar, { children: _jsx(SecondaryBtn, { isDanger: true, onClick: handleDeleteAllMeasurementsBtnClick, children: _jsx(FormattedMessage, { ...measureMessages.measureDeleteAll }) }) }))] }));
};
//# sourceMappingURL=Measure.js.map